import { useState } from "react";
import clsx from "clsx";
import { useAddColorToCollection } from "../../add-color-to-collection";
import { useAddToColorCollectionModalStore } from "../../../js/stores/add-to-color-collection-modal-store";
import { useEditColorCollectionFromSavedColors } from "../../../js/api/my-saved-colors/add-saved-colors-to-collection";
import { SharedIcon } from "../shared/shared-icon";
import { toast } from "../../../js/components/toast";

export function AddColorToCollectionButton() {
  const [isLoading, setIsLoading] = useState(false);
  const iconId = isLoading ? "#sprite-spinner" : "#sprite-plus";

  const {
    isLoggedIn,
    addToCollectionUrl,
    addToCollectionLabel,
    addToSelectedCollectionUrl,
    colorCode,
    collectionId,
  } = useAddColorToCollection();

  const openModal = useAddToColorCollectionModalStore(
    (state) => state.openModal
  );

  const editColorCollectionMutation = useEditColorCollectionFromSavedColors();

  const showToastMessage = ({ isSuccess, message }) => {
    const toastTypeFunc = isSuccess ? toast.success : toast.error;
    toastTypeFunc(null, message);
  };

  const onOpenPickCollectionModalClick = () => {
    openModal(addToCollectionUrl);
  };

  const onAddToSelectedCollectionClick = () => {
    if (!collectionId || !addToSelectedCollectionUrl) return;

    setIsLoading(true);
    const body = {
      collectionIds: [collectionId],
      code: colorCode,
    };
    editColorCollectionMutation.mutate({
      url: addToSelectedCollectionUrl,
      body,
      successHandler: (response) => {
        setIsLoading(false);
        showToastMessage(response);
      },
      errorHandler: () => {
        setIsLoading(false);
      },
    });
  };

  const onAddClick = collectionId
    ? onAddToSelectedCollectionClick
    : onOpenPickCollectionModalClick;

  return (
    isLoggedIn && (
      <button
        type="button"
        className="save-single-color-button button grey"
        onClick={onAddClick}
      >
        <span>{addToCollectionLabel}</span>
      </button>
    )
  );
}
